import { SimpleGrid, Skeleton } from '@mantine/core'
import { range } from 'lodash'

const EscalationModalSkeleton = ({
  fieldsNum,
  height,
}: {
  fieldsNum: number
  height: string
}) => {
  return (
    <SimpleGrid cols={{ base: 1, xs: 2 }} spacing="lg" p={10} h={height}>
      {range(0, fieldsNum).map((row) => (
        <Skeleton key={row} height={40} />
      ))}
    </SimpleGrid>
  )
}

export default EscalationModalSkeleton
